import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.rolle-zentrale-setzen';
import * as api from '../../../clients/incidents';

@Injectable()
export class IncidentsRolleZentraleSetzenEffects {

    RolleZentraleSetzen$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_ROLLE_ZENTRALE_SETZEN),
        mergeMap((x: ac.PostRolleZentraleSetzenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postRolleZentraleSetzen(x.incidentsRolleOptionenRequest).pipe(
                map((result: any) => {
                    return new ac.PostRolleZentraleSetzenErfolgreichAction(result, x.incidentsRolleOptionenRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostRolleZentraleSetzenFehlerAction(error, x.incidentsRolleOptionenRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.IncidentsCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.IncidentsCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.IncidentsCommandService);
        }
        return this.service;
    }
}
